var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0057 8.79281H22.1309V0.791504H25.0057C27.4033 0.791504 28.8787 2.28899 28.8787 4.79216C28.8787 7.2898 27.4033 8.79281 25.0057 8.79281ZM23.9751 7.17929H24.9406C26.2859 7.18481 27.0236 6.52725 27.0236 4.79216C27.0236 3.05154 26.2859 2.3995 24.919 2.39398H23.9751V7.17929Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0405 0.791504V8.79281H32.1962V0.791504H34.0405Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3305 8.79281H37.4556V0.791504H40.3305C42.728 0.791504 44.2034 2.28899 44.2034 4.79216C44.2034 7.2898 42.728 8.79281 40.3305 8.79281ZM39.2999 7.17929H40.2654C41.6106 7.18481 42.3483 6.52725 42.3483 4.79216C42.3483 3.05154 41.6106 2.3995 40.2437 2.39398H39.2999V7.17929Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.885742 21.1346V15.7648H2.88108C4.09882 15.7648 4.74803 16.5139 4.7517 17.5449C4.74803 18.5721 4.09148 19.3175 2.8664 19.3175H1.83939V21.1346H0.885742ZM1.83939 18.5239H2.73436C3.45327 18.5202 3.77604 18.1123 3.77604 17.5449C3.77604 16.9701 3.45327 16.5733 2.73436 16.5733H1.83939V18.5239Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27788 21.1346V15.7648H10.2315V20.3188H12.579V21.1346H9.27788Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9781 21.1346H16.9585L18.8291 15.7648H20.0028L21.8808 21.1346H20.8611L20.4173 19.807H18.4183L17.9781 21.1346ZM18.675 19.0283H20.1605L19.4379 16.8625H19.3939L18.675 19.0283Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3873 16.5733V15.7648H29.62V16.5733H27.9841V21.1346H27.0305V16.5733H25.3873Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1242 21.1346V15.7648H37.528V16.5733H35.0778V18.0418H37.2933V18.8503H35.0778V21.1346H34.1242Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8298 18.4497C46.8334 20.1853 45.7844 21.2088 44.3943 21.2088C42.9968 21.2088 41.9552 20.1816 41.9588 18.4497C41.9552 16.7142 42.9968 15.6907 44.3943 15.6907C45.7844 15.6907 46.8334 16.7142 46.8298 18.4497ZM42.9198 18.4497C42.9161 19.6772 43.5287 20.341 44.3943 20.341C45.2636 20.341 45.8725 19.6772 45.8688 18.4497C45.8725 17.2223 45.2636 16.5584 44.3943 16.5584C43.5287 16.5584 42.9161 17.2223 42.9198 18.4497Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4367 21.1346V15.7648H53.432C54.6497 15.7648 55.2989 16.4546 55.3026 17.4781C55.2989 18.2087 54.9688 18.7501 54.3453 19.006L55.4933 21.1346H54.4297L53.388 19.1692H52.3903V21.1346H51.4367ZM52.3903 18.3607H53.2853C54.0042 18.3645 54.327 18.0529 54.327 17.4781C54.327 16.907 54.0042 16.5733 53.2853 16.5733H52.3903V18.3607Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8801 15.7648H61.0539L62.6311 19.6661H62.6971L64.2743 15.7648H65.448V21.1346H64.531V17.4411H64.4797L63.0052 21.1198H62.323L60.8485 17.4262H60.8045V21.1346H59.8801V15.7648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewLogo);
export default __webpack_public_path__ + "static/media/preview-logo.fe3b9e2a1ed33f738f4a1c348c023cd3.svg";
export { ForwardRef as ReactComponent };